export default [
  {
    path: '/rewards',
    name: 'rewards',
    component: () => import('@/views/marketing/rewards/pages/RewardsList.vue'),
    meta: {
      resource: 'rewards',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Rewards',
      breadcrumb: [
        {
          text: 'Rewards',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/challenges',
    name: 'challenges',
    component: () => import('@/views/marketing/rewards/challenge-management/pages/ChallengeList.vue'),
    meta: {
      resource: 'rewards',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Challenges',
      breadcrumb: [
        {
          text: 'Challenges',
          active: true,
        },
      ],
    },
  },
  {
    path: '/create-reward',
    name: 'create-reward',
    component: () => import('@/views/marketing/rewards/pages/CreateReward.vue'),
    meta: {
      resource: 'rewards',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Rewards',
      breadcrumb: [
        {
          text: 'Rewards',
          to: '/rewards',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/edit-reward/:id',
    name: 'edit-reward',
    component: () => import('@/views/marketing/rewards/pages/EditReward.vue'),
    meta: {
      resource: 'rewards',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Rewards',
      breadcrumb: [
        {
          text: 'Rewards',
          to: '/rewards',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/create-challenge',
    name: 'create-challenge',
    component: () => import('@/views/marketing/rewards/challenge-management/pages/CreateChallenge.vue'),
    meta: {
      resource: 'rewards',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Challenges',
      breadcrumb: [
        {
          text: 'Challenges',
          to: '/challenges',
        },
      ],
    },
  },
  {
    path: '/edit-challenge/:id',
    name: 'edit-challenge',
    component: () => import('@/views/marketing/rewards/challenge-management/pages/EditChallenge.vue'),
    meta: {
      resource: 'rewards',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Challenges',
      breadcrumb: [
        {
          text: 'Challenges',
          to: '/challenges',
        },
      ],
    },
  },
]
